import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LocationProvider } from "@/context/LocationContext";

import ClientLayout from "@/components/ClientLayout";
import Home from "@/pages/client/Home";
import OfferDetail from "@/pages/client/OfferDetail";
import StorePage from "@/pages/client/StorePage";
import MyCoupons from "@/pages/client/MyCoupons";
import CouponRedeem from "@/pages/client/CouponRedeem";
import Account from "@/pages/client/Account";
import ClientMessages from "@/pages/client/ClientMessages";
import ClientFavorites from "@/pages/client/ClientFavorites";
import OffersMap from "@/pages/client/OffersMap";

import VendorLogin from "@/pages/vendor/VendorLogin";
import VendorLayout from "@/pages/vendor/VendorLayout";
import Dashboard from "@/pages/vendor/Dashboard";
import Offers from "@/pages/vendor/Offers";
import Validate from "@/pages/vendor/Validate";
import StoreSetup from "@/pages/vendor/StoreSetup";
import History from "@/pages/vendor/History";
import VendorMessages from "@/pages/vendor/VendorMessages";
import VendorFollowers from "@/pages/vendor/VendorFollowers";
import VendorCoupons from "@/pages/vendor/VendorCoupons";
import VendorCouponClients from "@/pages/vendor/VendorCouponClients";
import VendorStats from "@/pages/vendor/VendorStats";
import VendorLoyalty from "@/pages/vendor/VendorLoyalty";
import VendorReviews from "@/pages/vendor/VendorReviews";
import VendorVerification from "@/pages/vendor/VendorVerification";

import AdminPanel from "@/pages/admin/AdminPanel";
import AuthCallback from "@/pages/AuthCallback";
import LegalPage from "@/pages/legal/LegalPage";
import OverflowGuard from "@/components/OverflowGuard";

function AppRoutes() {
  const location = useLocation();
  // OAuth callback: process session_id synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      {/* Client (public browsing) */}
      <Route element={<ClientLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/map" element={<OffersMap />} />
        <Route path="/offer/:id" element={<OfferDetail />} />
        <Route path="/store/:id" element={<StorePage />} />
        <Route path="/coupons" element={<MyCoupons />} />
        <Route path="/coupon/:claimId" element={<CouponRedeem />} />
        <Route path="/account" element={<Account />} />
        <Route path="/messages" element={<ClientMessages />} />
        <Route path="/favorites" element={<ClientFavorites />} />
      </Route>

      {/* Vendor */}
      <Route path="/vendor/login" element={<VendorLogin />} />
      <Route path="/vendor" element={<VendorLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="offers" element={<Offers />} />
        <Route path="validate" element={<Validate />} />
        <Route path="coupon-clients" element={<VendorCouponClients />} />
        <Route path="reviews" element={<VendorReviews />} />
        <Route path="messages" element={<VendorMessages />} />
        <Route path="messages/loyalty" element={<VendorLoyalty />} />
        <Route path="followers" element={<VendorFollowers />} />
        <Route path="coupons" element={<VendorCoupons />} />
        <Route path="stats" element={<VendorStats />} />
        <Route path="history" element={<History />} />
        <Route path="store" element={<StoreSetup />} />
        <Route path="verification" element={<VendorVerification />} />
      </Route>

      {/* Admin */}
      <Route path="/admin" element={<AdminPanel />} />

      {/* Legal / public documents */}
      <Route path="/legal/:slug" element={<LegalPage />} />

      {/* OAuth callback (direct route) */}
      <Route path="/auth/callback" element={<AuthCallback />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <LocationProvider>
        <BrowserRouter>
          <OverflowGuard />
          <AppRoutes />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </LocationProvider>
    </AuthProvider>
  );
}

export default App;
